import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux'
import {
    updateVisitorConfigurationRequest, updateVisitorConfigurationRequestStatus,
    getVisitorConfigurationRequest
} from '../../../redux/visitor/visitor.action'
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import Select from 'react-select'
import { API_CONSTANTS, APP_CONSTANTS } from "../../../utils/AppConstants";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import CommonCheckbox from "../../../components/common-checkbox/commonCheckbox";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";

const VisitorSettingScreen = props => {
    const dispatch = useDispatch()
    const [isLoading, setLoading] = useState(false)
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector((state) => state.user)
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const { visitorUpdateConfigurationSuccess, visitorUpdateConfigurationError, visitorUpdateConfigurationReqStatus,
        visitorGetConfigurationSuccess, visitorGetConfigurationError } = useSelector((state) => state.visitor)
    const [showVisitorName, setShowVisitorName] = useState(true)
    const [showVisitorContact, setShowVisitorContact] = useState(true)
    const [showVisitorEmailId, setShowVisitorEmailId] = useState(false)
    const [showVisitorAddress, setShowVisitorAddress] = useState(false)
    const [showVisitorCompanyName, setShowVisitorCompanyName] = useState(false)
    const [showVisitorVehicleInformation, setShowVisitorVehicleInformation] = useState(false)
    const [showVisitorId, setShowVisitorId] = useState(false)
    const [showVisitorImage, setShowVisitorImage] = useState(false)
    const [showPurpose, setShowPurpose] = useState(false)
    const [showHostName, setShowHostName] = useState(false)
    const [showHostEmailId, setShowHostEmailId] = useState(false)
    const [showHostMobile, setShowHostMobile] = useState(false)
    const [showVisitorNameMandatory, setShowVisitorNameMandatory] = useState(false)
    const [showVisitorContactMandatory, setShowVisitorContactMandatory] = useState(false)
    const [showVisitorEmailIdMandatory, setShowVisitorEmailIdMandatory] = useState(false)
    const [showVisitorAddressMandatory, setShowVisitorAddressMandatory] = useState(false)
    const [showVisitorCompanyNameMandatory, setShowVisitorCompanyNameMandatory] = useState(false)
    const [showVisitorVehicleInformationMandatory, setShowVisitorVehicleInformationMandatory] = useState(false)
    const [showVisitorIdMandatory, setShowVisitorIdMandatory] = useState(false)
    const [showVisitorImageMandatory, setShowVisitorImageMandatory] = useState(false)
    const [showPurposeMandatory, setShowPurposeMandatory] = useState(false)
    const [showHostNameMandatory, setShowHostNameMandatory] = useState(false)
    const [showHostEmailIdMandatory, setShowHostEmailIdMandatory] = useState(false)
    const [showHostMobileMandatory, setShowHostMobileMandatory] = useState(false)

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.VISITOR_SETTING_SCREEN, true)
            fetchBusinessList()
        } else if (isLoggedInUserEmployee(user)) {
            fetchFormConfiguration()
        }
    }, [])

    const fetchFormConfiguration = () => {
        setLoading(true)
        const data = {
            businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
            locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation
        }
        dispatch(getVisitorConfigurationRequest(data))
    }

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (visitorUpdateConfigurationReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(visitorUpdateConfigurationSuccess.data?.message)
            fetchFormConfiguration()
        } else if (visitorUpdateConfigurationReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(visitorUpdateConfigurationError.message)
        }
        if (visitorUpdateConfigurationReqStatus?.length) {
            dispatch(updateVisitorConfigurationRequestStatus(''))
        }
    }, [visitorUpdateConfigurationSuccess, visitorUpdateConfigurationError, visitorUpdateConfigurationReqStatus])

    useEffect(() => {
        if (!isEmpty(visitorGetConfigurationSuccess)) {
            setLoading(false)
            if (visitorGetConfigurationSuccess.data.isConfigError === true) {
                displayErrorToast('Error occurred while getting configuration.')
            } else if (visitorGetConfigurationSuccess.data.isConfigAvailable === false) {
                displayErrorToast('No configuration set. Please set-up check-in form configuration')
            } else if (visitorGetConfigurationSuccess.data.isConfigAvailable === true) {
                prefillConfiguration(visitorGetConfigurationSuccess.data.configDetails)
            }
        } else if (!isEmpty(visitorGetConfigurationError)) {
            setLoading(false)
            displayErrorToast(visitorGetConfigurationError.message)
        }
    }, [visitorGetConfigurationSuccess, visitorGetConfigurationError])

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.VISITOR_SETTING_SCREEN) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.VISITOR_SETTING_SCREEN, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedLocation)) {
            fetchFormConfiguration()
        }
    }, [selectedLocation])

    const prefillConfiguration = (data) => {
        data.visitorConfig.forEach(element => {
            if (element.type === 'visitorName') {
                setShowVisitorName(element.display)
                setShowVisitorNameMandatory(element.isMandatory)
            } else if (element.type === 'visitorPhoneNumber') {
                setShowVisitorContact(element.display)
                setShowVisitorContactMandatory(element.isMandatory)
            } else if (element.type === 'visitorAddress') {
                setShowVisitorAddress(element.display)
                setShowVisitorAddressMandatory(element.isMandatory)
            } else if (element.type === 'visitorEmailId') {
                setShowVisitorEmailId(element.display)
                setShowVisitorEmailIdMandatory(element.isMandatory)
            } else if (element.type === 'visitorCompanyName') {
                setShowVisitorCompanyName(element.display)
                setShowVisitorCompanyNameMandatory(element.isMandatory)
            } else if (element.type === 'visitorVehicleInformation') {
                setShowVisitorVehicleInformation(element.display)
                setShowVisitorVehicleInformationMandatory(element.isMandatory)
            } else if (element.type === 'visitorId') {
                setShowVisitorId(element.display)
                setShowVisitorIdMandatory(element.isMandatory)
            } else if (element.type === 'hostName') {
                setShowHostName(element.display)
                setShowHostNameMandatory(element.isMandatory)
            } else if (element.type === 'hostPhoneNumber') {
                setShowHostMobile(element.display)
                setShowHostMobileMandatory(element.isMandatory)
            } else if (element.type === 'hostEmailId') {
                setShowHostEmailId(element.display)
                setShowHostEmailIdMandatory(element.isMandatory)
            } else if (element.type === 'purpose') {
                setShowPurpose(element.display)
                setShowPurposeMandatory(element.isMandatory)
            } else if (element.type === 'visitorImage') {
                setShowVisitorImage(element.display)
                setShowVisitorImageMandatory(element.isMandatory)
            }
        });
    }

    const handleUpdateSubmitClick = () => {
        let config = [
            { type: 'visitorName', display: showVisitorName, isMandatory: showVisitorNameMandatory },
            { type: 'visitorPhoneNumber', display: showVisitorContact, isMandatory: showVisitorContactMandatory },
            { type: 'visitorEmailId', display: showVisitorEmailId, isMandatory: showVisitorEmailIdMandatory },
            { type: 'visitorAddress', display: showVisitorAddress, isMandatory: showVisitorAddressMandatory },
            { type: 'visitorCompanyName', display: showVisitorCompanyName, isMandatory: showVisitorCompanyNameMandatory },
            { type: 'visitorVehicleInformation', display: showVisitorVehicleInformation, isMandatory: showVisitorVehicleInformationMandatory },
            { type: 'visitorId', display: showVisitorId, isMandatory: showVisitorIdMandatory },
            { type: 'hostName', display: showHostName, isMandatory: showHostNameMandatory },
            { type: 'hostPhoneNumber', display: showHostMobile, isMandatory: showHostMobileMandatory },
            { type: 'hostEmailId', display: showHostEmailId, isMandatory: showHostEmailIdMandatory },
            { type: 'purpose', display: showPurpose, isMandatory: showPurposeMandatory },
            { type: 'visitorImage', display: showVisitorImage, isMandatory: showVisitorImageMandatory }
        ]
        const data = {
            businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
            locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation,
            visitorConfig: config
        }
        setLoading(true)
        dispatch(updateVisitorConfigurationRequest(data))
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Settings' />
                {isLoggedInUserBusiness(user) === true && <CommonInputRow>
                    <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    </div>
                    {!isEmpty(selectedBusiness) && <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                </CommonInputRow>}
                <CommonFormBorder>
                    <div className="table-scroll-container">
                        <table className="table table-hover mt-1">
                            <thead>
                                <tr>
                                    <th scope="col">Field Name</th>
                                    <th scope="col" className="text-center">Visibility</th>
                                    <th scope="col" className="text-center">Is Mandatory</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="loc-table-row-container">
                                    <td className="loc-list-card-name1">Visitor Image</td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                id='visitorImage'
                                                label=''
                                                noWidth={true}
                                                showLabel={false}
                                                value={showVisitorImage}
                                                onChange={() => {
                                                    setShowVisitorImage(!showVisitorImage)
                                                }}
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                id='visitorImageMandatory'
                                                noWidth={true}
                                                showLabel={false}
                                                label=''
                                                value={showVisitorImageMandatory}
                                                onChange={() => {
                                                    setShowVisitorImageMandatory(!showVisitorImageMandatory)
                                                }}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr className="loc-table-row-container">
                                    <td className="loc-list-card-name1">Visitor Name</td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                id='visitorName'
                                                noWidth={true}
                                                showLabel={false}
                                                label=''
                                                value={showVisitorName}
                                                onChange={() => {
                                                    setShowVisitorName(!showVisitorName)
                                                }}
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                id='visitorNameMandatory'
                                                label=''
                                                noWidth={true}
                                                showLabel={false}
                                                value={showVisitorNameMandatory}
                                                onChange={() => {
                                                    setShowVisitorNameMandatory(!showVisitorNameMandatory)
                                                }}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr className="loc-table-row-container">
                                    <td className="loc-list-card-name1">Visitor Phone Number</td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                id='phoneNumber'
                                                noWidth={true}
                                                showLabel={false}
                                                label=''
                                                value={showVisitorContact}
                                                onChange={() => {
                                                    setShowVisitorContact(!showVisitorContact)
                                                }}
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                id='phoneNumberMandatory'
                                                noWidth={true}
                                                showLabel={false}
                                                label=''
                                                value={showVisitorContactMandatory}
                                                onChange={() => {
                                                    setShowVisitorContactMandatory(!showVisitorContactMandatory)
                                                }}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr className="loc-table-row-container">
                                    <td className="loc-list-card-name1">Visitor Email Id</td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                id='email'
                                                label=''
                                                noWidth={true}
                                                showLabel={false}
                                                value={showVisitorEmailId}
                                                onChange={() => {
                                                    setShowVisitorEmailId(!showVisitorEmailId)
                                                }}
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                id='emailMandatory'
                                                label=''
                                                noWidth={true}
                                                showLabel={false}
                                                value={showVisitorEmailIdMandatory}
                                                onChange={() => {
                                                    setShowVisitorEmailIdMandatory(!showVisitorEmailIdMandatory)
                                                }}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr className="loc-table-row-container">
                                    <td className="loc-list-card-name1">Visitor Company Name</td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                id='companyName'
                                                noWidth={true}
                                                showLabel={false}
                                                label=''
                                                value={showVisitorCompanyName}
                                                onChange={() => {
                                                    setShowVisitorCompanyName(!showVisitorCompanyName)
                                                }}
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                id='companyNameMandatory'
                                                label=''
                                                noWidth={true}
                                                showLabel={false}
                                                value={showVisitorCompanyNameMandatory}
                                                onChange={() => {
                                                    setShowVisitorCompanyNameMandatory(!showVisitorCompanyNameMandatory)
                                                }}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr className="loc-table-row-container">
                                    <td className="loc-list-card-name1">Visitor Address</td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                id='address'
                                                noWidth={true}
                                                showLabel={false}
                                                label=''
                                                value={showVisitorAddress}
                                                onChange={() => {
                                                    setShowVisitorAddress(!showVisitorAddress)
                                                }}
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                id='addressMandatory'
                                                noWidth={true}
                                                showLabel={false}
                                                label=''
                                                value={showVisitorAddressMandatory}
                                                onChange={() => {
                                                    setShowVisitorAddressMandatory(!showVisitorAddressMandatory)
                                                }}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr className="loc-table-row-container">
                                    <td className="loc-list-card-name1">Visitor Id</td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                id='id'
                                                noWidth={true}
                                                showLabel={false}
                                                label=''
                                                value={showVisitorId}
                                                onChange={() => {
                                                    setShowVisitorId(!showVisitorId)
                                                }}
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                id='idMandatory'
                                                noWidth={true}
                                                showLabel={false}
                                                label=''
                                                value={showVisitorIdMandatory}
                                                onChange={() => {
                                                    setShowVisitorIdMandatory(!showVisitorIdMandatory)
                                                }}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr className="loc-table-row-container">
                                    <td className="loc-list-card-name1">Visitor Vehicle Information</td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                id='vehicleInfo'
                                                noWidth={true}
                                                showLabel={false}
                                                label=''
                                                value={showVisitorVehicleInformation}
                                                onChange={() => {
                                                    setShowVisitorVehicleInformation(!showVisitorVehicleInformation)
                                                }}
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                noWidth={true}
                                                showLabel={false}
                                                id='vehicleInfoMandatory'
                                                label=''
                                                value={showVisitorVehicleInformationMandatory}
                                                onChange={() => {
                                                    setShowVisitorVehicleInformationMandatory(!showVisitorVehicleInformationMandatory)
                                                }}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr className="loc-table-row-container">
                                    <td className="loc-list-card-name1">Purpose</td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                noWidth={true}
                                                showLabel={false}
                                                id='vehicleInfoMandatory'
                                                label=''
                                                value={showPurpose}
                                                onChange={() => {
                                                    setShowPurpose(!showPurpose)
                                                }}
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                noWidth={true}
                                                showLabel={false}
                                                id='vehicleInfoMandatory'
                                                label=''
                                                value={showPurposeMandatory}
                                                onChange={() => {
                                                    setShowPurposeMandatory(!showPurposeMandatory)
                                                }}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr className="loc-table-row-container">
                                    <td className="loc-list-card-name1">Host Name</td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                noWidth={true}
                                                showLabel={false}
                                                id='hostName'
                                                label=''
                                                value={showHostName}
                                                onChange={() => {
                                                    setShowHostName(!showHostName)
                                                }}
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                noWidth={true}
                                                showLabel={false}
                                                id='hostNameMandatory'
                                                label=''
                                                value={showHostNameMandatory}
                                                onChange={() => {
                                                    setShowHostNameMandatory(!showHostNameMandatory)
                                                }}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr className="loc-table-row-container">
                                    <td className="loc-list-card-name1">Host Contact</td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                noWidth={true}
                                                showLabel={false}
                                                id='hostContact'
                                                label=''
                                                value={showHostMobile}
                                                onChange={() => {
                                                    setShowHostMobile(!showHostMobile)
                                                }}
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                noWidth={true}
                                                showLabel={false}
                                                id='hostContactMandatory'
                                                label=''
                                                value={showHostMobileMandatory}
                                                onChange={() => {
                                                    setShowHostMobileMandatory(!showHostMobileMandatory)
                                                }}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr className="loc-table-row-container">
                                    <td className="loc-list-card-name1">Host Email Id</td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                noWidth={true}
                                                showLabel={false}
                                                id='hostEmail'
                                                label=''
                                                value={showHostEmailId}
                                                onChange={() => {
                                                    setShowHostEmailId(!showHostEmailId)
                                                }}
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="vss-cb-container">
                                            <CommonCheckbox
                                                id='hostEmailMandatory'
                                                noWidth={true}
                                                showLabel={false}
                                                label=''
                                                value={showHostEmailIdMandatory}
                                                onChange={() => {
                                                    setShowHostEmailIdMandatory(!showHostEmailIdMandatory)
                                                }}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <ButtonRow>
                        <CommonButton label='Update' onClick={() => { handleUpdateSubmitClick() }} />
                    </ButtonRow>
                </CommonFormBorder>
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default VisitorSettingScreen